export enum TestStatus {
  All = 'all',
  Booked = 'booked',
  None = 'none'
}
